import React from "react";
import { UserPlus, ClipboardList, Calendar, Receipt, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const MODULES = [
  {
    tag: "01",
    icon: UserPlus,
    title: "Discover",
    text: "Sign up your clinic in 60 seconds. Import or add patients with auto-UHID.",
  },
  {
    tag: "02",
    icon: ClipboardList,
    title: "Chart",
    text: "Mark cavities, RCTs, crowns on the interactive FDI teeth chart with notes.",
  },
  {
    tag: "03",
    icon: Calendar,
    title: "Schedule",
    text: "Book appointments and send WhatsApp reminders in one click.",
  },
  {
    tag: "04",
    icon: Receipt,
    title: "Bill",
    text: "Generate GST-ready invoices, print or share as PDF.",
  },
];

const Modules = () => {
  const nav = useNavigate();
  return (
    <section id="modules" className="relative bg-[#0F2A5F] py-20 md:py-28 overflow-hidden">
      {/* decorative */}
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#14B8A6]/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-[#14B8A6]/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-[1200px] mx-auto px-6">
        <div className="max-w-2xl mb-14">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#14B8A6] mb-3">
            The Dotmedy way
          </div>
          <h2
            className="text-3xl md:text-[42px] font-extrabold text-white leading-tight mb-4"
            style={{ fontFamily: "'Open Sans', sans-serif" }}
          >
            From patient walk-in to paid invoice — in four steps.
          </h2>
          <p className="text-white/70 text-lg">
            A clean, opinionated workflow that removes the noise so you can
            focus on treatment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {MODULES.map((m) => (
            <div
              key={m.tag}
              className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="w-11 h-11 rounded-lg bg-[#14B8A6] text-white flex items-center justify-center">
                  <m.icon size={20} />
                </div>
                <span className="text-3xl font-black text-white/10">{m.tag}</span>
              </div>
              <h3 className="text-white font-bold text-xl mb-2">{m.title}</h3>
              <p className="text-white/70 text-sm leading-relaxed">{m.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => nav("/register")}
            className="inline-flex items-center gap-2 bg-[#14B8A6] hover:bg-[#0F8A7D] text-white font-semibold px-6 py-3.5 rounded-lg transition-colors shadow-lg shadow-black/20"
          >
            Try Dotmedy free <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Modules;
